var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CallUs text-align__left font-size__16px"},_vm._l((_vm.callList),function(item,index){return _c('div',{key:index},[_c('div',[_vm._v(_vm._s(item.label))]),_c('div',{on:{"click":function($event){return _vm.Copy(item)}}},[_vm._v(" "+_vm._s(item.content)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }